export default "<button (click)=\"login()\" class=\"btn btn-primary\">Login with Google</button>\n"